// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';

export class HalloweenSwiper 
{
	// alert('swiper');
	constructor(){
		const swiper = new Swiper('.swiper', {
			modules:[Navigation, Pagination, Scrollbar],
			// slidesPerView: 2,
			loop: true,
			
			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
        clickable: true
			},
		
			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints:{
				0: { 
					slidesPerView: 1,
					spaceBetween: '28px', 
				},
				768: { 
					slidesPerView: 2,
					spaceBetween: '28px', 
				},
				1024: { 
					slidesPerView: 2,
					spaceBetween: '78px', 
				},
			}
		
			// And if we need scrollbar
			// scrollbar: {
			// 	el: '.swiper-scrollbar',
			// },
		});
	}
}